<template>
  <div class="card">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CCard'
}
</script>

<style scoped>
.card {
  margin-bottom: var(--grid-spacing);
  padding: 20px;

  background-color: #fff;
}

.card > :first-child {
  margin-top: 0;
}

.card > :last-child {
  margin-bottom: 0;
}
</style>
